module.exports = "<div class=\"pageBlock\">\n  <h2 class=\"wow FadeInLegacyUp\">שאלות ותשובות</h2>\n  <text [divId]=\"'questions'\"></text>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/questionsanswers.component.html
// module id = ./src/app/header/questionsanswers.component.html
// module chunks = main